var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame",style:({ paddingRight: _vm.align === 'left' ? '50px' : '0px' })},[_c('div',[_vm._v(" "+_vm._s(_vm.formattedSum)+" ")]),_c('span',{staticClass:"currency"},[_vm._v("₽")])])}
var staticRenderFns = []

export { render, staticRenderFns }